export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'jobPositions' as const;

export const RELATIONSHIP_TYPES = {
  JOB: 'job',
  ROLE: 'role',
} as const;

export const POSITION_TYPES = {
  REGULAR: 'regular',
  CUSTOM: 'custom',
} as const;
